import React from "react";
import PopUpLoader from "@components/popup";
import Intro3 from "src/components/intro/Intro";
import { isUSAdWordsSEM } from "@utils/userSegment";
import { AWSemHead, LandingHead } from "@heads/HealthWeight";
import { usePageView } from "src/hooks/tracking";

import { useCampaign, useCoreState } from "src/hooks/redux";
import { useOnce } from "src/hooks/lifecycle";
import { usePageSet } from "src/hooks/pageSet";
import { conditionsPass, PageCondition } from "../pageDefinitions/conditions";
import { CoreReduxState } from "src/utils/redux/internal";
import { LandingFooter } from "src/components/footer/LandingFooter";
import { useLandingLegacyRedirect } from "src/hooks/legacy-redirect";

function evalSkipNext(
  skipNext: boolean | ReadonlyArray<PageCondition>,
  state: CoreReduxState
) {
  if (skipNext === true) {
    return true;
  }
  if (skipNext) {
    return !!conditionsPass(skipNext, state).score;
  }
  return false;
}

export default function LandingPage() {
  const { activePage, gotoNextPage } = usePageSet();

  const state = useCoreState();
  const campaign = useCampaign();

  const redirecting = useLandingLegacyRedirect();

  // If we're not on a legacy path then track as a landing PV.
  usePageView("landing");

  useOnce(() => {
    // If the pageset has another page they wish to jump directly to, do so.
    if (!redirecting && evalSkipNext(activePage.props?.skipToNext, state)) {
      gotoNextPage(true);
    }
  });

  if (redirecting) {
    return null;
  }

  // Return null for removing the UI glitch of showing and hiding the original Landing Page
  if (evalSkipNext(activePage.props?.skipToNext, state)) {
    return null;
  }

  return (
    <div>
      {isUSAdWordsSEM() ? <AWSemHead /> : <LandingHead />}
      <div>
        {campaign.popup && <PopUpLoader data={campaign.popup} />}
        <Intro3 />
      </div>
      <LandingFooter />
    </div>
  );
}
